<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
          <vue-element-loading size='64' is-full-screen :active='isLoadingForm' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>إعداد كشوف التحصيل</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                              هنا يتم تحديد وانشاء كشوف التحصيل و الصيانة
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                    <label>الفرع</label>
                                    <select  @change='FillItineraries()' class="form-control"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                    <label>الخط</label>
                                    <select @change='FillRegions($event.target.value)'  class="form-control"  v-model="line">
                                      <option v-for="item in lines" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>المنطقة:</label>
                                <select class="form-control" style="padding: 0px" v-model="region_id">
                                  <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.region_name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate  :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <tbDate  :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                              <div class='col-lg-2 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>كود السجل</label>
                                  <input v-model='rec_id_letter' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>من رقم</label>
                                  <input v-model='from_id' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>الى رقم</label>
                                  <input v-model='to_id' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>&nbsp;</label>
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> عرض </b>
                                </button>
                              </div>
                              <div style="padding:10px">
                              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                  <thead>
                                    <tr>
                                      <th style='padding:2px;text-align: center'>م</th>
                                      <th style='padding:2px;text-align: center'>السجل</th>
                                      <th style='padding:2px;text-align: center'>الاسم</th>
                                      <th style='padding:2px;text-align: center'>اسم الشهرة</th>
                                      <th style='padding:2px;text-align: center'>المحمول</th>
                                      <th style='padding:2px;text-align: center'>المنطقة</th>
                                      <th style='padding:2px;text-align: center'>العنوان</th>
                                      <th style='padding:2px;text-align: center'>الاجراء</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr class='odd gradeX' v-for='(record,index) in records' :key='index'>

                                         <td align='center'>{{index +1 }}</td>
                                         <td align='center'>{{record.rec_id}} {{record.rec_id_letter}}</td>
                                         <td align='center'>{{record.name}}</td>
                                         <td align='center'>{{record.nickname}}</td>
                                        <td align='center'>{{record.mobile}} {{record.mobile2}}</td>
                                        <td align='center'>{{record.region_name}}</td>
                                        <td align='center'>{{record.village}} {{record.address}}</td>
                                        <td align='center'>
                                          <button @click='GetAllCustomerData(record.uid)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#ContractsForm'>عرض</button>
                                        </td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- ================ Contracts Modal Begin ======================================== -->
             <div class="modal fade" id="ContractsForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                 <div class="modal-dialog modal-lg">
                     <div class="modal-content">
                         <div class="modal-header">
                             <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                             <h4 class="modal-title" id="myModalLabel">{{contTitle}}</h4>
                         </div>
                         <div class="modal-body">
                           <div class="panel-body" style="padding:0px">

                            <vue-tabs active-tab-color="#6DBCF1"
                                      active-text-color="white"
                                      centered
                                      v-model="tabName"
                                      @tab-change="handleTabChange">
                                      <v-tab title="إدراج" icon="ti-user">
                                        <CollectingSheets ref="CollectingSheets"> </CollectingSheets>
                                      </v-tab>
                                      <v-tab title="بيانات العميل" icon="ti-user">
                                        <Data ref="Data"> </Data>
                                      </v-tab>

                               <v-tab :disabled="disabled" id = "1" title="العقود" icon="ti-settings">
                                 <Contracts ref="Contracts"> </Contracts>
                               </v-tab>
                               <v-tab :disabled="disabled"  id = "2" title="السداد" icon="ti-check">
                                 <InstallmentPaymrnt ref="InstallmentPaymrnt"> </InstallmentPaymrnt>
                               </v-tab>
                               <v-tab :disabled="disabled" title="طلبات الصيانة" icon="ti-check">
                                 <MaintenanceRequest  ref="MaintenanceRequest"> </MaintenanceRequest>
                               </v-tab>
                               <v-tab :disabled="disabled" title="الصيانة" icon="ti-check">
                                 <Maintenance  ref="Maintenance"> </Maintenance>
                               </v-tab>
                               <v-tab :disabled="disabled" title="التحصيل" icon="ti-check">
                                 <receipts ref="receipt"> </receipts>
                               </v-tab>
                           </vue-tabs>
                         </div>
<!-- //////////////////////////////////.panel-heading -->
                               <!-- Nav tabs -->

                           <!-- /.panel-body -->
                         </div>
                         <div style="align-content: center;" class="modal-footer">
                             <button type="button" class="btn btn-default" data-dismiss="modal">خروج</button>
                         </div>
                     </div>
                 </div>
                 <!-- /.modal-dialog -->
             </div>
    <!-- ================  /.modal-content ======================================== -->
             <!-- /. Contracts modal End -->
             <!-- /.container-fluid -->
        </div>
</template>
<style>
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import Swal from 'sweetalert2'
import CollectingSheets from '@/components/Sales/CollectingSheets'
import Receipts from '@/components/Sales/Contracts/Receipts'
import Contracts from '@/components/Sales/Contracts/Contracts'
import InstallmentPaymrnt from '@/components/Sales/Contracts/InstallmentPaymrnt'
import Data from '@/components/Sales/Contracts/Data'
import Maintenance from '@/components/Sales/Contracts/Maintenance'
import MaintenanceRequest from '@/components/Sales/Contracts/MaintenanceRequest'
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'createCollectingstatement',
  components: {
    Receipts,
    Contracts,
    InstallmentPaymrnt,
    MaintenanceRequest,
    Maintenance,
    CollectingSheets,
    Data,
    tbDate
  },
  data () {
    return {
      dateTitle: 'التاريخ',
      fromTitle: 'من',
      toTitle: 'إلى',
      from_date: '',
      to_date: '',
      emptyRec: [{id: 0, name: 0}],
      validationErrors: '',
      pagination: {},
      region_id: {},
      regions: '',
      records: {},
      lines: {},
      line: '',
      record: {},
      printRecord: [],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingForm: false,
      isLoadingDelete: false,
      printRecords: [],
      branches: {},
      governorates: {},
      cities: {},
      itineraries: {},
      tabName: 'إدراج',
      title: '',
      disabled: true,
      id: '',
      rec_id_letter: '',
      name: '',
      contTitle: '',
      branche: 0,
      brancheID: 0,
      itinerarie: 0,
      notes: '',
      governorate: '',
      city: '',
      village: '',
      isActive: '',
      balance: '',
      sorte: 'rec_id',
      evaluation: '',
      mobile: '',
      from_id: '',
      to_id: ''
    }
  },
  mounted: function () {
    this.$root.$on('Update_Totals', (id, ind, mai, total, contractId, balance) => {
      let i = this.records.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.records[i].balance = balance
        this.$refs.Contracts.updateTotal(contractId, ind, mai)
      }
    })
    this.$root.$on('SET_Title', (Title) => {
      this.contTitle = Title
    })
    this.$root.$on('SET_Records', (RecordData, Type) => {
      this.disabled = false
      this.$refs.Contracts.UpdateData(RecordData.branche_id)
      this.$refs.InstallmentPaymrnt.UpdateData(RecordData.branche_id)
      this.$refs.Maintenance.UpdateData(RecordData.branche_id)
      this.$refs.receipt.UpdateData(RecordData.branche_id)
      this.$refs.CollectingSheets.GetData(this.from_date, this.to_date)
      if (Type === 0) {
        this.records.push(RecordData)
      } else {
        let i = this.records.map(record => record.id).indexOf(RecordData.id)
        this.records.splice(i, 1, RecordData)
      }
      this.$refs.Contracts.GetData()
    })
  },
  created () {
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.branche = this.branches[0].id
    this.FillItineraries()
    this.getOffres()
  },
  methods: {
    getOffres () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getActiveOffers', {
        token: localStorage.getItem('token')
      })
        .then(({ data }) => {
          localStorage.setItem('offers', JSON.stringify(data))
          this.isLoadingData = false
        })
    },
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branche))
      if (i > -1) {
        this.brancheID = i
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.lines.unshift(this.emptyRec)
        this.line = 0
      }
    },
    FillRegions (id) {
      this.regions = ''
      this.region_id = ''
      if (id != null && id.length !== 0) {
        let i = this.branches[this.brancheID].itineraries.findIndex(x => x.id === parseInt(this.line))
        if (i > -1) {
          this.regions = JSON.parse(JSON.stringify(this.branches[this.brancheID].itineraries[i].regions))
          this.regions.unshift(this.emptyRec)
        }
      }
    },
    saveNots () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'saveNotes', {
        token: localStorage.getItem('token'),
        notes: this.notes,
        id: this.$store.state.customerData.id
      })
        .then(({ data }) => {
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'GetCollectingSheetData', {
        token: localStorage.getItem('token'),
        line_id: this.line,
        branch_id: this.branche,
        region_id: this.region_id,
        date_from: this.from_date,
        date_to: this.to_date,
        rec_id_letter: this.rec_id_letter,
        from_id: this.from_id,
        to_id: this.to_id
      })
        .then(({ data }) => {
          this.records = data
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    handleTabChange (tabIndex, newTab, oldTab) {
      if (newTab.id === '2') {
        // this.$refs.InstallmentPaymrnt.EmptyCombo()
      }
    },
    GetprintData () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getPrintCustomers', {
        token: localStorage.getItem('token'),
        id: this.id,
        name: this.name,
        governorate: this.governorate,
        city: this.city,
        village: this.village,
        rec_id_letter: this.rec_id_letter,
        branche: this.branche,
        itinerarie: this.itinerarie,
        isActive: this.isActive,
        balance: this.balance,
        sorte: this.sorte,
        evaluation: this.evaluation,
        mobile: this.mobile
      })
        .then(({ data }) => {
          this.printRecords = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetAllCustomerData (uid) {
      this.isLoadingForm = true
      this.tabName = 'إدراج'
      axios.post(this.$apiURL + 'getAllCustomerData', {
        token: localStorage.getItem('token'),
        uid: uid
      })
        .then(res => {
          this.isLoadingForm = false
          this.$store.dispatch('getAllCustomerData', res.data[0])
          this.disabled = false
          this.contTitle = 'بيانات العميل رقم ' + this.$store.state.customerData.id + ' : ' + this.$store.state.customerData.name + ' [ ' + 'كود سجل ' + this.$store.state.customerData.rec_id + ' ]'
          this.$refs.CollectingSheets.GetData(this.from_date, this.to_date, this.branche)
          this.$refs.Data.FillData(uid)
          // -----------------------------
          if (this.$per.value.Contract_show) {
            this.$refs.Contracts.GetData()
          }
          // -----------------------------
          if (this.$per.value.Receipt_show) {
            this.$refs.receipt.GetData()
          }
          // -----------------------------
          if (this.$per.value.Maintenance_show) {
            this.$refs.Maintenance.GetData()
          }
          // -----------------------------
          if (this.$per.value.InstallmentPaymrnt_show) {
            this.$refs.InstallmentPaymrnt.GetData()
          }
          // -----------------------------
          if (this.$per.value.MaintenanceRequest_show) {
            this.$refs.MaintenanceRequest.GetData()
          }
          // -----------------------------
          if (this.$per.value.Notes_show) {
            this.notes = this.$store.state.customerData.notes
          }
        })
        .catch(err => {
          if (uid !== 0) {
            if (err.response.data.errors === 'Forbidden') {
              this.$router.push('accessdeny')
            }
            if (err.response.status === 401) {
              this.$router.push('login')
            }
          }
        })
    },
    deleteData (uid, id) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteCustomer', {
            token: localStorage.getItem('token'),
            id: uid
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              let i = this.records.map(record => record.id).indexOf(id)
              this.records.splice(i, 1)
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateCollectingstatement.vue